module.exports = __webpack_public_path__ + "static/media/marketing_laptop_color.8cbd7b1e.png";